import ContractsService from '@/services/apiRequests/contracts.service';
import { wait } from '@/utils';

export default {
    namespaced: true,
    state: {
        contractDebt: null,
        rowCount: 0,
        filterOptions: {
            sum_debt: null,
            object_name: null,
            isServiceConnected: null,
            contract_number: null,
            selectedDistrictRid: null,
            notice_status_type_rid: null,
            selectedAddress: {}
        },
        notices: null,
        noticesLoading: false,
        noticesLength: 0,
        noticesPaginationOptions: {
            page: 0,
            itemsPerPage: 10
        },
        noticesFilterOptions: {
            main_dolg: null,
            name: null,
            serial_number: null,
            selectedAddress: {},
            doc_create_date: null,
            doc_delivery_date: null,
            doc_signed: null,
            doc_delivered: null
        },
        noticeDetails: {},
        objectContracts: {
            objects: [],
            pagination: {
                page: 0,
                itemsPerPage: 5
            },
            rowCount: 0,
            isLoading: false
        }
    },
    getters: {
        getContractDebt(state) {
            return state.contractDebt;
        },
        getRowCount(state) {
            return state.rowCount;
        },
        getNotices(state) {
            return state.notices;
        },
        getNoticesLoading(state) {
            return state.noticesLoading;
        },
        getNoticesLength(state) {
            return state.noticesLength;
        },
        getNoticesPaginationOptions(state) {
            return state.noticesPaginationOptions;
        },
        getNoticeDetails(state) {
            return state.noticeDetails;
        },
        getObjectContracts(state) {
            return state.objectContracts;
        }
    },
    mutations: {
        setContractDebt(state, data) {
            state.contractDebt = data;
        },
        setRowCount(state, rowCount) {
            state.rowCount = rowCount;
        },
        setFilterOptions(state, filterOptions) {
            state.filterOptions = filterOptions;
        },
        setNotices(state, notices) {
            state.notices = notices;
        },
        setNoticesLoading(state, isLoading) {
            state.noticesLoading = isLoading;
        },
        setNoticesLength(state, length) {
            state.noticesLength = length;
        },
        setNoticesPage(state, page) {
            state.noticesPaginationOptions.page = page;
        },
        setNoticesFilterOptions(state, filterOptions) {
            state.noticesFilterOptions = filterOptions;
        },
        setNoticeDetails(state, details) {
            state.noticeDetails = details;
        },
        setObjectContracts(state, objects) {
            state.objectContracts.objects = objects;
        },
        setObjectContractsRowCount(state, rowCount) {
            state.objectContracts.rowCount = rowCount;
        },
        setObjectContractIsLoading(state, isLoading) {
            state.objectContracts.isLoading = isLoading;
        }
    },
    actions: {
        async getContractDebt({ state, commit }, { currentItem, itemsPerPage }) {
            const is_connected = state.filterOptions.isServiceConnected == 1 ? true : state.filterOptions.isServiceConnected == 0 ? false : null;
            const payloadData = {
                currentItem: currentItem,
                itemsPerPage: itemsPerPage,
                iWhereOrderLocale: {
                    where: [
                        { field: 'sum_debt', value: state.filterOptions.sum_debt },
                        { field: 'contract_number', value: state.filterOptions.contract_number },
                        { field: 'object_name', value: state.filterOptions.object_name },
                        { field: 'address_rid', value: state.filterOptions.selectedAddress.record_id },
                        { field: 'district_rid', value: state.filterOptions.selectedDistrictRid },
                        { field: 'is_connected', value: is_connected },
                        { field: 'notice_status_type_rid', value: state.filterOptions.notice_status_type_rid }
                    ]
                }
            };
            const response = await ContractsService.getContractDebt(payloadData);
            if (response) {
                commit('setContractDebt', response.data['ahs_contracts']);
                commit('setRowCount', response.data.pagination['row_count']);
            }
        },
        setFilterOptions({ commit }, filterOptions) {
            commit('setFilterOptions', { ...filterOptions });
        },
        async getPreTrialNotices({ state, commit }) {
            const { page, itemsPerPage } = state.noticesPaginationOptions;
            const {
                main_dolg,
                name,
                serial_number,
                selectedAddress,
                doc_create_date,
                doc_delivery_date,
                doc_signed,
                doc_delivered
            } = state.noticesFilterOptions;
            const is_signed = doc_signed == 1 ? true : doc_signed == 0 ? false : null;
            const is_delivered = doc_delivered == 1 ? true : doc_delivered == 0 ? false : null;
            const payloadData = {
                currentItem: page,
                itemsPerPage,
                iWhereOrderLocale: {
                    where: [
                        { field: 'consumption_category', value: null },
                        { field: 'contract_number', value: serial_number },
                        { field: 'contractor_name___ru', value: name },
                        { field: 'address_rid', value: selectedAddress.record_id },
                        { field: 'doc_create_date', value: doc_create_date },
                        { field: 'debts_info', value: main_dolg },
                        { field: 'doc_delivery_date', value: doc_delivery_date },
                        { field: 'doc_signed', value: is_signed },
                        { field: 'doc_delivered', value: is_delivered }
                    ]
                }
            };
            commit('setNoticesLoading', true);
            const response = await ContractsService.getPreTrialNotices(payloadData);
            let notices = [];
            let changedNotices = [];
            if (response) {
                notices = response.data['ahs_Contracts_PreTrialNotices'] || [];
                commit('setNoticesLength', response.data['pagination']['row_count']);
                changedNotices = notices.map(notice => {
                    const { contract_operation_action_rid, contract_number, contractor_name___ru, contractor_name___kz, ...rest } = notice;
                    return {
                        ...rest,
                        id: contract_operation_action_rid,
                        serial_number: contract_number,
                        name___ru: contractor_name___ru,
                        name___kz: contractor_name___kz
                    };
                });
            }
            commit('setNotices', changedNotices);
            commit('setNoticesLoading', false);
        },
        setNoticesFilterOptions({ state, commit }, filterOptions) {
            commit('setNoticesFilterOptions', filterOptions);
            commit('setNoticesPage', 0);
        },
        async printNoticePdf({ state }, selectedPreTrials) {
            const response = await ContractsService.getPreTrialNoticePDF(selectedPreTrials);

            const base64EncodedPDF = response.data;
            const newWindow = window.open();

            newWindow.document.write('<iframe width="100%" height="100%" src="data:application/pdf;base64,' + base64EncodedPDF + '"></iframe>');

            newWindow.onload = function() {
                newWindow.print();
            };
        },
        async setPreTrialNoticeDetails({ state, commit }, id) {
            const response = await ContractsService.getPreTrialNoticeDetails(id);

            const keyMapping = {
                contract_open_date: 'open_date',
                contract_number: 'serial_number',
                contractor_name___ru: 'name___ru',
                contractor_name___kz: 'name___kz',
                contract_operation_action_guid: 'guid',
                contract_operation_action_rid: 'id'
            };
            const updatedObject = Object.fromEntries(Object.entries(response.data).map(([key, value]) => [keyMapping[key] || key, value]));
            commit('setNoticeDetails', updatedObject);
        },
        async getUserObjectContractsList({ state, commit }, contract_rid) {
            const payload = {
                contract_rid,
                currentItem: state.objectContracts.pagination.page,
                itemsPerPage: state.objectContracts.pagination.itemsPerPage
            };
            commit('setObjectContractIsLoading', true);
            const response = await ContractsService.getUserObjectContractsList(payload);
            // await wait(1000);
            commit('setObjectContractIsLoading', false);
            if (!response.successfull || !response) return;
            commit('setObjectContracts', response.data['object_contracts']);
            commit('setObjectContractsRowCount', response.data.pagination['row_count']);
        }
    }
};
